import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "colors-list" }
const _hoisted_2 = ["src"]

import { computed, onMounted, ref } from 'vue';
import { uniqueId } from 'lodash';
import i18n from '@/plugins/i18n';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
import { storeToRefs } from 'pinia';
import { useEditorStore } from '@/store/editor';

interface IColor {
  id: string;
  color: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ColorsList',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { generateImageData } = storeToRefs(useEditorStore());
const emit = __emit;
const selectedColorId = ref<string | null>(null);
const isColorPickerVisible = ref<boolean>(false);
const colors = ref<IColor[]>([]);

const colorValue = computed({
  get() {
    return props.modelValue;
  },
  set(newVal) {
    emit('update:modelValue', newVal);
  },
});
const computedColors = computed(() => {
  const resultColors = [...colors.value];
  // const resColorIndex = colors.value.findIndex((color: IColor) => color.color === colorValue.value);
  // if (resColorIndex === -1 && colorValue.value) {
  //   resultColors.splice(0, 1);
  //   resultColors.unshift({
  //     id: '111111',
  //     color: colorValue.value,
  //   });
  reAssignSelectedColor();
  // }
  return resultColors;
});

const selectColor = (color: IColor | null): void => {
  selectedColorId.value = color?.id || null;
  if (!color) {
    resetHandler();
  } else {
    emit('update:modelValue', color.color);
  }
};

const valueToHex = (c: number): string => {
  const hex = c.toString(16);
  return hex;
};
const rgbToHex = (r: number, g: number, b: number): string => valueToHex(r) + valueToHex(g) + valueToHex(b);

const updateColor = (eventData: any): void => {
  const { cssColor } = eventData;
  const isRgb = cssColor.startsWith('rgb');

  if (!isRgb) {
    colorValue.value = cssColor;
    return;
  }

  const rgbColors = cssColor
    .substring(4, cssColor.length - 1)
    .split(' ')
    .map((item: string) => Math.round(parseFloat(item)));

  const hexValue = rgbToHex(rgbColors[0], rgbColors[1], rgbColors[2]);
  colorValue.value = `#${hexValue}`;
};
function onColorPickerBtnClick(): void {
  isColorPickerVisible.value = !isColorPickerVisible.value;
  // if (!isColorPickerVisible.value) emitDifference();
  if (!isColorPickerVisible.value) return;
  const txt = i18n.global.t('apply');
  setTimeout(() => {
    const colorPicker = document.querySelector('.color-picker__inputs-picker');
    if (!colorPicker) return;
    const btn = document.createElement('button');
    const btnText = document.createTextNode(txt);
    btn.appendChild(btnText);
    btn.classList.add('btn-apply');
    colorPicker.appendChild(btn);
    btn.addEventListener('click', () => {
      const activator = document.querySelector('#color-picker-activator') as HTMLElement;
      activator?.click();
    });
  }, 5);
}

const onColorPickerOutsideClick = (): void => {
  if (isColorPickerVisible.value === false) return; // if click happened onColorPickerBtnClick
  isColorPickerVisible.value = false;
  emitDifference();
};

const emitDifference = (): void => {
  if (colorValue.value === '') {
    return;
  }
  const id = uniqueId('color-');
  emit('update:modelValue', colorValue.value);
  if (colorValue.value) {
    colors.value.unshift({ color: colorValue.value, id });
    colors.value = colors.value.splice(0, 4);
  }
};

const resetHandler = (): void => {
  selectedColorId.value = null;
  emit('update:modelValue', '');
};
const reAssignSelectedColor = (): void => {
  const tmpSelectedColorIndex = colors.value.findIndex((color: IColor) => color.color === props.modelValue);
  if (tmpSelectedColorIndex !== -1) {
    selectedColorId.value = colors.value[tmpSelectedColorIndex]?.id;
  }
};

onMounted(async () => {
  if (generateImageData.value?.color) {
    colors.value.push({ color: generateImageData.value.color, id: '1234' });
  }
  if (props.modelValue !== '' && props.modelValue !== null) {
    reAssignSelectedColor();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_color_picker = _resolveComponent("color-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AiClearButton, {
        onClick: onColorPickerBtnClick,
        id: "colors-list-activator",
        class: "colors-list__btn"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_inline_svg, {
            class: "colors-list__indicator__cleared__icon",
            src: require('@/assets/icons/plus.svg')
          }, null, 8, ["src"])
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: _normalizeClass(["colors-list__btn", { 'colors-list__btn--selected': !selectedColorId.value }])
      }, [
        _createVNode(AiClearButton, {
          onClick: resetHandler,
          class: "colors-list__btn__inner"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: require('@/assets/icons/editor/removeBg.svg'),
              alt: ""
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        })
      ], 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedColors.value, (color) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "colors-list__option",
          key: color.id
        }, [
          _createElementVNode("div", {
            style: _normalizeStyle({ backgroundColor: color.color }),
            class: _normalizeClass([{ 'colors-list__btn--selected': selectedColorId.value === color.id }, "colors-list__btn"])
          }, [
            _createVNode(AiClearButton, {
              onClick: ($event: any) => (selectColor(color)),
              class: "colors-list__btn__inner"
            }, null, 8, ["onClick"])
          ], 6)
        ]))
      }), 128))
    ]),
    _createVNode(_component_v_menu, {
      activator: "#colors-list-activator",
      "close-on-content-click": false
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_color_picker, {
          onColorChange: updateColor,
          style: {"color":"black","background-color":"white"},
          id: "colors-list__inputs-picker",
          class: "colors-list__inputs-picker",
          color: colorValue.value ? colorValue.value : '#c52323',
          "visible-formats": ['hex', 'rgb'],
          "default-format": "hex",
          "alpha-channel": "hide"
        }, null, 8, ["color"]), [
          [_directive_click_outside, onColorPickerOutsideClick]
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})